import { DialogActions, DialogContent, styled } from "@mui/material";

export const StyledPrintAndDownloadDialog = {
  TitleContainer: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: 10,
    backgroundColor: theme.palette.secondary.dark,
  })),
  DialogContainer: styled(DialogContent, {
    shouldForwardProp: (prop) => prop !== "showActionButtons", // Excluye "showActionButtons" de pasar como atributo al DOM
  })(({ theme, showActionButtons }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingLeft: 40,
    paddingRight: 40,
    paddingBottom: 20,
    overflow: "auto",
    height: showActionButtons ? "calc(100vh - 166px)" : "100%",
  })),
  Actions: styled(DialogActions)(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    backgroundColor: "white",
    paddingRight: 10,
    boxShadow: "0px 0 5px lightGrey",
  })),
  LoadingContainer: styled("div")(({ theme }) => ({
    marginTop: 80,
    marginBottom: 80,
    width: "100%",
  })),
  PrintButtonContainer: styled("div")(({ theme }) => ({
    display: "none",
  })),
  PrintButton: styled("div")(({ theme }) => ({
    margin: "20px",
  })),
};
